import PropTypes from 'prop-types';
import React from 'react';

import { Flex, Box } from 'reflexbox';

import {
  Divider,
  Heading,
} from 'rebass';

import If from 'frontend/components/If';

const TextDivider = ({ text, left, right, ...textProps }) => (
  <Flex align="center" justify="space-between">
    <If
      condition={left}
      then={() => (
        <Box auto>
          <Divider />
        </Box>
      )}
    />
    <Heading level={6} ml={left ? 3 : 0} mr={right ? 3 : 0} {...textProps}>{text}</Heading>
    <If
      condition={right}
      then={() => (
        <Box auto>
          <Divider />
        </Box>
      )}
    />
  </Flex>
);

TextDivider.propTypes = {
  text: PropTypes.string.isRequired,
  left: PropTypes.bool,
  right: PropTypes.bool,
};

TextDivider.defaultProps = {
  left: true,
  right: true,
};

export default TextDivider;
